import { FC, PropsWithChildren } from 'react'

import { LayoutProvider } from './LayoutProvider'
import { ReactQueryProvider } from './ReactQueryProvider'
import { AppProvider } from './AppProvider'

export const Providers: FC<PropsWithChildren> = props => (
  <LayoutProvider>
    <ReactQueryProvider>
      <AppProvider>{props.children}</AppProvider>
    </ReactQueryProvider>
  </LayoutProvider>
)
